module.exports = __webpack_public_path__ + "static/media/our_services_side_link.ce70e1da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sideLinks/our_services_side_link.svg
// module id = 186
// module chunks = 0